import { ProductionCostInfo } from "./ProductionCostInfo";
import React from "react";
import { Badge } from "@/components/ui/badge";
import { formatMoney } from "@/lib/api/manufacturing";

export function SimulationCostSummary({ totals, productCount = 0, itemCount = 0, title = "Resumen de simulación" }) {
  const averageCost = Number(totals?.total_quantity || 0) > 0 ? Number(totals.grand_total || 0) / Number(totals.total_quantity || 1) : 0;

  return (
    <div className="rounded-lg border bg-white p-4 shadow-sm">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="font-semibold">{title} <ProductionCostInfo lines={totals?.overhead_lines || []} /></h3>
          <p className="text-sm text-gray-600">Coste directo previsto según escandallos, sin estructura / gastos generales.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Badge variant="outline">{productCount} articulos</Badge>
          <Badge variant="outline">{itemCount} líneas de color</Badge>
        </div>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        <div className="rounded border bg-gray-50 p-3">
          <div className="text-xs uppercase text-gray-500">Unidades</div>
          <div className="text-xl font-bold">{totals?.total_quantity || 0}</div>
        </div>
        <div className="rounded border bg-gray-50 p-3">
          <div className="text-xs uppercase text-gray-500">Procesos</div>
          <div className="text-xl font-bold">{formatMoney(totals?.process_total || 0)}</div>
        </div>
        <div className="rounded border bg-gray-50 p-3">
          <div className="text-xs uppercase text-gray-500">Materiales</div>
          <div className="text-xl font-bold">{formatMoney(totals?.material_total || 0)}</div>
        </div>
        <div className="rounded border bg-blue-50 p-3">
          <div className="text-xs uppercase text-blue-700">Total</div>
          <div className="text-xl font-bold text-blue-900">{formatMoney(totals?.grand_total || 0)}</div>
        </div>
        <div className="rounded border bg-gray-50 p-3">
          <div className="text-xs uppercase text-gray-500">Coste medio</div>
          <div className="text-xl font-bold">{formatMoney(averageCost)}</div>
        </div>
      </div>
    </div>
  );
}
